import { SnowplowService } from 'wanderu-service-analytics';

function localePromptClicked({ currentLocale, detectedLocale }) {
    SnowplowService.fireStructuredEvent({
        category: 'locale_switch_prompt',
        action: 'click',
        label: 'locale_changed',
        property: {
            prev_locale: currentLocale,
            new_locale: detectedLocale,
        },
    });
}

export default {
    localePromptClicked,
};
